import { useEffect } from "react";
import { getData } from "../../../api/apiCalls";

export const StatsBanner = () => {

   useEffect(() => {
      // getData(`https://youngstartup.io/api/cwebsite/get_speakers`)
      //    .then((data) => data)
      //    .then((data) => {
      //    });
   }, []);

   return (
      <div className="theme-bg-gradient" style={{ display: 'flex', flexDirection: 'column', padding: window.innerWidth < 768 ? "8%" : "1.2%", gap: '2.5vh' }}>
         <h1 style={{ fontWeight: 'bold', textAlign: 'center', color: 'white', fontSize: window.innerWidth < 769 && "1.15rem" }}>Where Innovation Meets Capital<sup>™</sup></h1>
         <div

            style={{
               display: "flex",
               justifyContent: "center",
               color: "white",
               gap: "6%",

               paddingTop: '0',
               flexWrap: "wrap",
               alignItems: "start",
               textAlign: "center",
               flexDirection: "row",
            }}
         >
            {window.innerWidth > 769 && <div
               style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "center",
                  width: window.innerWidth < 768 ? "40%" : "",
               }}
            >
               <h1>$260B</h1>
               <h4>Under Management</h4>
            </div>}
            <div
               style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "center",
                  width: window.innerWidth < 768 ? "40%" : "",
               }}
            >
               <h1 style={{ fontSize: window.innerWidth < 769 && '1.7rem' }}>1000</h1>
               <h4 style={{ fontSize: window.innerWidth < 769 && '1rem' }}>Attendees</h4>
            </div>
            <div
               style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "center",
                  width: window.innerWidth < 768 ? "40%" : "",
               }}
            >
               <h1 style={{ fontSize: window.innerWidth < 769 && '1.7rem' }}>
                  260
               </h1>
               <h4 style={{ fontSize: window.innerWidth < 769 && '1rem' }}>Featured Investors</h4>
            </div>
            <div
               style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "center",
                  width: window.innerWidth < 768 ? "40%" : "",
               }}
            >
               <h1 style={{ fontSize: window.innerWidth < 769 && '1.7rem' }}>100</h1>
               <h4 style={{ fontSize: window.innerWidth < 769 && '1rem' }}>Top Innovators</h4>
            </div>
            <div
               style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "center",
                  width: window.innerWidth < 768 ? "40%" : "",
               }}
            >
               <h1 style={{ fontSize: window.innerWidth < 769 && '1.7rem' }}>2500</h1>
               <h4 style={{ fontSize: window.innerWidth < 769 && '1rem' }}>1 on 1 Meetings</h4>
            </div>
         </div>
      </div>
   );
};
